import React from "react";

import { elementConstants } from "../../constants/cms/form/element/element.constants";

import QuestionSettings from "../elements/element/Question/Settings/QuestionSettings";
import FieldSettings from "../elements/element/Field/Settings/FieldSettings";
import EventSettings from "../elements/element/Event/Settings/EventSettings";
import ContentSettings from "../elements/element/Content/Settings/ContentSettings";
import ContainerSettings from "../elements/element/Container/Settings/ContainerSettings";
import PaymentOptionSettings from "../elements/element/PaymentOptions/Settings/PaymentOptionSettings";
import UserPageSettings from "../elements/element/UserPage/Settings/UserPageSettings";
import { emailElementType } from "../areas/email/constants/emailElementType.constants";
import SimpleButtonSettings from "../areas/email/elements/SimpleButton/SimpleButton.settings";
import EmptySpaceSettings from "../areas/email/elements/EmptySpace/EmptySpace.settings";
import TextAreaSettings from "../areas/email/elements/TextArea/TextArea.settings";
import BackgroundImageWithText from "../areas/email/elements/BackgroundImageWithText/BackgroundImageWithText.settings";
import LargeHeaderImageSettings from "../areas/email/elements/LargeHeaderImage/LargeHeaderImage.settings";
import SmallHeaderImageSettings from "../areas/email/elements/SmallHeaderImage/SmallHeaderImage.settings";
import ProfileImageUploaderSettings from "../elements/element/ProfileImageUploader/Settings/ProfileImageUploaderSettings";
import DiscountSettings from "../elements/element/Discount/Settings/DiscountSettings";
import CalendarInvitationSettings from "../areas/email/elements/CalendarInvitation/CalendarInvitation.settings";
import GroupRegistrationSettings from "../elements/element/GroupRegistration/Settings/GroupRegistrationSettings";
import FileUploaderSettings from "../elements/element/FileUploader/Settings/FileUploaderSettings";

export const renderElementSettings = (type, element, toggleConditionModal) => {
  switch (type) {
    case elementConstants.EVENT:
      if (!element.props) return null;
      return <EventSettings element={element} toggleConditionModal={toggleConditionModal} />;
    case elementConstants.QUESTION:
      if (!element.props) return null;
      return <QuestionSettings element={element} toggleConditionModal={toggleConditionModal} />;
    case elementConstants.FIELD:
      if (!element.props) return null;
      return <FieldSettings element={element} toggleConditionModal={toggleConditionModal} />;
    case elementConstants.CONTENT:
      return <ContentSettings toggleConditionModal={toggleConditionModal} />;
    case elementConstants.PAYMENT_OPTIONS:
      return <PaymentOptionSettings element={element}></PaymentOptionSettings>;
    case elementConstants.CONTAINER:
      return <ContainerSettings element={element} toggleConditionModal={toggleConditionModal} />;
    case elementConstants.USER_PAGE:
      return <UserPageSettings element={element} />;
    case emailElementType.BUTTON:
      return <SimpleButtonSettings />;
    case emailElementType.SPACE:
      return <EmptySpaceSettings />;
    case emailElementType.TEXT:
      return <TextAreaSettings />;
    case emailElementType.LARGE_HEADER_IMAGE:
      return <LargeHeaderImageSettings />;
    case emailElementType.CALENDAR_INVITATION:
      return <CalendarInvitationSettings />;
    case emailElementType.SMALL_HEADER_IMAGE:
      return <SmallHeaderImageSettings />;
    case emailElementType.BACKDROPIMAGE_ELEVATED_TEXT:
      return <BackgroundImageWithText />;
    case elementConstants.PROFILEIMAGE_UPLOAD:
      return <ProfileImageUploaderSettings />;
    case elementConstants.DISCOUNT:
      return <DiscountSettings />;
    case elementConstants.GROUP_REGISTRATION:
      return <GroupRegistrationSettings />;
    case elementConstants.FILE_UPLOADER:
      return <FileUploaderSettings />;
    default:
      return null;
  }
};
